import { useGeo } from '@/context/GeoContext';
import { isUSCountryCode } from '@/services/countryCode';

export function useIsUS(): boolean {
  const { countryCode } = useGeo();

  return isUSCountryCode(countryCode);
}
